<template>
  <Form
    ref="elementRef"
    :class="this.props.className"
    :style="this.props.style"
    :model="model[modelKey]"
    :rules="this.props.rules"
    :inline="this.props.inline"
    :label-position="this.props.labelPosition"
    :label-width="this.props.labelWidth"
    :show-message="this.props.showMessage"
    :autocomplete="this.props.autocomplete"
    :hide-required-mark="this.props.hideRequiredMark"
    :label-colon="this.props.labelColon"
    :disabled="disabled"
    @on-validate="validateHandle"
  >
    <Row :gutter=20>
      <Col
        :key="formItem.key"
        v-for="formItem in formItems"
        :span="formItem.span"
        :xs="formItem.xs"
        :sm="formItem.sm"
        :md="formItem.md"
        :lg="formItem.lg"
        :xl="formItem.xl"
        :xxl="formItem.xxl"
        :offset="formItem.offset"
      >
      <!-- :prop="formItem.key" -->
        <FormItem
        
          :label="formItem.label"
          :label-width="formItem.labelWidth"
          :style="formItem.style"
        >
          <!-- 控件 -->
          <j2-dispatcher :element-info="formItem"></j2-dispatcher>
        </FormItem>
      </Col>
    </Row>
  </Form>
</template>

<script>
import CommonUtil from "../../util/CommonUtil";
import ModelUtil from "../../util/ModelUtil";
import ExpressionUtil from "../../util/ExpressionUtil";

export default {
  name: "FormComponent",
  props: ["elementIndex", "props", "displayData", "detailList"],
  beforeMount: function() {
    var me = this;
    var validators = {
      equals: function(rule, value, callback) {
        var formModel = me.model[me.modelKey];
        if (value !== formModel[rule.target]) {
          callback(new Error(rule.message));
        } else {
          callback();
        }
      }
    };
    // ClassName
    if (this.props.className == null) this.$set(this.props, "className", null);
    // 样式
    if (this.props.style == null) this.$set(this.props, "style", null);
    // 表单验证规则，具体配置查看  async-validator
    if (this.props.rules == null) this.$set(this.props, "rules", null);
    if (this.props.rules) {
      for (var key in this.props.rules) {
        if (this.props.rules[key]) {
          for (var idx in this.props.rules[key]) {
            if (this.props.rules[key][idx].validator) {
              this.props.rules[key][idx].validator = validators[this.props.rules[key][idx].validator];
            }
          }
        } else {
          if (this.props.rules[key].validator) {
            this.props.rules[key].validator = validators[this.props.rules[key].validator];
          }
        }
      }
    }
    // 是否开启行内表单模式
    if (this.props.inline == null) this.$set(this.props, "inline", false);
    // 表单域标签的位置，可选值为 left、right、top
    if (this.props.labelPosition == null)
      this.$set(this.props, "labelPosition", "right");
    // 表单域标签的宽度，所有的 FormItem 都会继承 Form 组件的 label-width 的值
    if (this.props.labelWidth == null) this.$set(this.props, "labelWidth", 100);
    if (this.props.labelWidth == "") this.$set(this.props, "labelWidth", null);
    // 是否显示校验错误信息
    if (this.props.showMessage == null)
      this.$set(this.props, "showMessage", true);
    // 原生的 autocomplete 属性，可选值为 off 或 on
    if (this.props.autocomplete == null)
      this.$set(this.props, "autocomplete", "off");
    // 是否隐藏所有表单项的必选标记
    if (this.props.hideRequiredMark == null) this.$set(this.props, "hideRequiredMark", false);
    // 是否自动在 label 名称后添加冒号
    if (this.props.labelColon == null) this.$set(this.props, "labelColon", true);
    // 是否禁用该表单内的所有组件（适用于具有 disabled 属性的表单类组件）
    if (this.props.disabled == null) this.$set(this.props, "disabled", false);
  },
  mounted: function() {
    CommonUtil.saveElementToStore(this);
  },
  computed: {
    model: function() {
      return ModelUtil.getModelObject(this, this.displayData);
    },
    modelKey: function() {
      return ModelUtil.getModelKey(this, this.displayData, {});
    },
    disabled: function() {
      return this.$store.getters.isLoading || this.props.disabled;
    },
    formItems: function() {
      var formItems = new Array();
      if (this.detailList) {
        for (let i = 0; i < this.detailList.length; i++) {
          var itemDetail = this.detailList[i];
          
          var propData = this.$store.getters.elementPropData['e' + this.elementIndex + 'd' + itemDetail.detailIndex];
          if (propData && this.columnVisible(propData.visible) == false) {
            continue;
          }

          // 列属性
          var itemProp = {};
          if (itemDetail.detailProp) {
            itemProp = JSON.parse(itemDetail.detailProp);
          }
          itemProp.label = itemDetail.detailName;
          itemProp.key = itemDetail.displayData;

          // 控件属性
          itemProp.elementIndex = itemDetail.elementIndex;
          itemProp.detailIndex = itemDetail.detailIndex;
          itemProp.displayType = itemDetail.displayType;
          itemProp.displayData = itemDetail.displayData;
          itemProp.detailModel = this.model[this.modelKey];
          itemProp.detailAddon = itemDetail.detailAddon;
          formItems.push(itemProp);
        }
      }
      return formItems;
    }
  },
  methods: {
    // 控件可见
    columnVisible: function(visible) {
      switch (typeof(visible)) {
        case "string":
          return ExpressionUtil.eval(this, "return " + visible);
        case "boolean":
          return visible;
        default:
          return true;
      }
    },
    validateHandle: function(prop, status, error) {
      // 任一表单项被校验后触发，返回表单项 prop、校验状态、错误消息
      if (this.props.onValidate) {
        ExpressionUtil.eval(this, this.props.onValidate, prop, status, error);
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pack/FormComponent.vue